/**
 * CUSTOM:VOLUMN-DISCOUNT-RANGE
 * Add/remove xo-custom-checked for exact, minimum, and inclusive quantity ranges.
 * Keep this customization separate from the original XO web component library.
 */
const productSelector = "xo-product[xo-product-information]";
const triggerSelector = ".xo-volume-discount__trigger[data-quantity-mode]";
const quantitySelector = 'xo-cart-quantity input[name="quantity"]';
const controlsSelector =
  "xo-cart-quantity-minus, xo-cart-quantity-plus, " + triggerSelector;
const priorities = { exact: 2, range: 1, at_least: 0 };

function getQuantityInput(product) {
  return Array.from(product.querySelectorAll(quantitySelector)).find(
    (input) =>
      input.closest("xo-product") === product &&
      !input.closest(
        "xo-product-variant, xo-product-variants, xo-bundle-content",
      ),
  );
}

function updateSelection(product, quantity) {
  const offers = Array.from(product.querySelectorAll(triggerSelector))
    .filter((trigger) => trigger.closest("xo-product") === product)
    .map((trigger) => {
      const minimum = Number(trigger.getAttribute("xo-value"));
      const maximum = Number(trigger.dataset.quantityMax);
      const mode = Object.hasOwn(priorities, trigger.dataset.quantityMode)
        ? trigger.dataset.quantityMode
        : "exact";
      const valid =
        Number.isInteger(quantity) &&
        quantity > 0 &&
        Number.isInteger(minimum) &&
        minimum > 0;
      const matches =
        valid &&
        (mode === "at_least"
          ? quantity >= minimum
          : mode === "range"
            ? quantity >= minimum && quantity <= maximum
            : quantity === minimum);

      return { trigger, minimum, mode, matches };
    });

  // CUSTOM:VOLUMN-DISCOUNT-RANGE — Prefer the highest threshold, then the more specific condition.
  const selected = offers
    .filter((offer) => offer.matches)
    .reduce((best, offer) => {
      if (
        !best ||
        offer.minimum > best.minimum ||
        (offer.minimum === best.minimum &&
          priorities[offer.mode] > priorities[best.mode])
      ) {
        return offer;
      }
      return best;
    }, null);

  offers.forEach((offer) => {
    const checked =
      selected !== null &&
      offer.matches &&
      offer.minimum === selected.minimum &&
      offer.mode === selected.mode;
    offer.trigger.toggleAttribute("xo-custom-checked", checked);
  });
}

function refreshSelection(product) {
  if (!product.isConnected) return;
  const input = getQuantityInput(product);
  const checkedTrigger = Array.from(
    product.querySelectorAll(triggerSelector),
  ).find(
    (trigger) =>
      trigger.closest("xo-product") === product &&
      trigger.hasAttribute("xo-checked"),
  );
  const quantity = input
    ? Number(input.value)
    : Number(checkedTrigger?.getAttribute("xo-value") || 1);
  updateSelection(product, quantity);
}

function onQuantityChange(event) {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches(quantitySelector))
    return;
  if (
    input.closest("xo-product-variant, xo-product-variants, xo-bundle-content")
  )
    return;
  const product = input.closest(productSelector);
  if (product && input.closest("xo-product") === product) {
    updateSelection(product, Number(input.value));
  }
}

// CUSTOM:VOLUMN-DISCOUNT-RANGE — Delegation covers input/change and replacement inputs.
document.addEventListener("input", onQuantityChange);
document.addEventListener("change", onQuantityChange);
document.addEventListener("click", (event) => {
  if (!(event.target instanceof Element)) return;
  const control = event.target.closest(controlsSelector);
  const product = control?.closest(productSelector);
  if (!product || control.closest("xo-product") !== product) return;
  if (
    control.closest(
      "xo-product-variant, xo-product-variants, xo-bundle-content",
    )
  )
    return;

  // CUSTOM:VOLUMN-DISCOUNT-RANGE — Native XO controls assign input.value without input/change events.
  queueMicrotask(() => refreshSelection(product));
});

function initialize(root = document) {
  if (root instanceof Element && root.matches(productSelector))
    refreshSelection(root);
  root.querySelectorAll(productSelector).forEach(refreshSelection);
}

document.addEventListener("shopify:section:load", (event) =>
  initialize(event.target),
);
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initialize(), {
    once: true,
  });
} else {
  initialize();
}
